import moment from 'moment';
import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';
import { Dropdown } from 'primereact/dropdown';
import { useEffect, useRef, useState } from 'react';
import { Col, Form, Row } from 'react-bootstrap';

function EditStatusDialog({
  visible,
  startDate,
  endDate,
  driver,
  vehicle,
  assigned,
  route,
  onHide,
  onSaved
}) {

  // #region vars and consts

  const [routeStatuses, setRouteStatuses] = useState([]);
  const [routeStatus, setRouteStatus] = useState(null);
  const [IsloadingRouteStatuses, setIsloadingRouteStatuses] = useState(false);

  // #endregion

  // #region methods

  const getRouteStatuses = () => {    
    setIsloadingRouteStatuses(true);
    fetch(`${process.env.REACT_APP_API_URL}/routeStatus/cmb`)
      .then(response => response.json())
      .then(data => {
        if (data.responseCode === 'OK') {
          setRouteStatuses(data.responseObject);          
        } else {
          console.warn('Error getting Route Statuses', data);
        }
        setIsloadingRouteStatuses(false);
      }).catch(error => {
        console.error('Error fetching Route Statuses:', error);
        setIsloadingRouteStatuses(false);
      });
  };

  const formatDate = (millisecondsDate) => {
    if (millisecondsDate > 0) {
      const dateMoment = moment(millisecondsDate);
      return dateMoment.format("DD/MM/YYYY hh:mm:ss a");
    } else {
      return '';
    }
  };

  const editStatus = (
    routeId,
    routeStatusId,
    orderId
  ) => {    
    fetch(`${process.env.REACT_APP_API_URL}/route/status`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        routeId,
        routeStatusId,
        orderId
      }),
    }).then(response => response.json()).then(data => {
      if (data.responseCode === 'OK') {        
        onSaved();                
      } else {
        console.log("Error updating status", data);
      }
    }).catch(error => {
      console.error("Error updating status", error);
    });
  };

  // #endregion

  // #region events

  useEffect(() => {    
    getRouteStatuses();    
  }, [visible]);

  const onDialogHide = () => {
    if (onHide) onHide();
  };

  const onClickSave = () => {    
    editStatus(
      route.routeId,
      routeStatus.routeStatusId,
      route.externalOrderId !== ''? route.orderEntityId : 0
    );
  };

  const onRouteStatuschange = (e) => {
    setRouteStatus(e.value);
  };
  
  // #endregion

  // #region templates

  const summaryTemplate = (
    <>
      <Row>
        <Col md={6}>
          <span>
            Folio vuelta:&nbsp;
            <b>
              {route ? route.routeId : ''}
            </b>
          </span>
        </Col>
        <Col md={6}>
          <span>
            Vehículo:&nbsp;
            <b>
              {route ? route.vehicleNo : ''}
            </b>
          </span>
        </Col>
      </Row>
      <Row>
        <Col md={6}>
          <span>
            Salida Aeropuerto:&nbsp;
            <b>
              {route ? formatDate(route.outAirportDateT) : ''}
            </b>
          </span>
        </Col>
        <Col md={6}>
          <span>
            Entrada Aeropuerto:&nbsp;
            <b>
              {route ? formatDate(route.inAirportDateT) : ''}
            </b>
          </span>
        </Col>
      </Row>
      <Row>
        <Col md={6}>
          <span>
            Zona:&nbsp;
            <b>
              {route ? route.zoneRouteDesc : ''}
            </b>
          </span>
        </Col>
      </Row>
    </>
  );

  const formTemplate = (
    <>
      <Row className='align-items-end'>
        <Col xs={12} sm={6} md={6} className='mb-2'>
          <Form.Group>
            <Form.Label>
              Estatus de Ruta
            </Form.Label>
            <Dropdown
              value={routeStatus}
              options={routeStatuses}
              onChange={onRouteStatuschange}
              optionLabel="description"
              placeholder="Selecciona el Estatus de Ruta"
              className='p-inputtext-sm w-100 app_dropdown'
              disabled={IsloadingRouteStatuses}              
              showClear
            />
          </Form.Group>
        </Col>
      </Row>      
    </>
  );

  const footerTemplate = (
    <>
      <Button
        type="button"
        icon="pi pi-save"        
        className="p-button-raised p-button-sm p-button-success p-fluid"
        label='Guardar'
        disabled={routeStatus === null}
        onClick={onClickSave}
      />
    </>
  );

  // #endregion

  return (
    <>
      <article>
        <Dialog
          header="Editar Estatus"
          footer={footerTemplate}
          visible={visible}
          onHide={onDialogHide}
          breakpoints={{ '960px': '75vw' }}
          style={{ width: '50vw' }}
        >
          <Row>
            <Col>
              {summaryTemplate}  
            </Col>
          </Row>
          <Row className='pt-5'>
            <Col>
              {formTemplate}
            </Col>
          </Row>
        </Dialog>
      </article>
    </>
  );
}

export default EditStatusDialog;